
<div style="margin-top: 20px; margin-left: 20px">

  <ng-container *ngIf="network=='google'">

    <h2>AdWords successfully integrated</h2>

  </ng-container>

  <ng-container *ngIf="network=='facebook'">

    <h2>Facebook successfully integrated</h2>

  </ng-container>

  <ng-container *ngIf="network=='shopify'">

    <h2>Shopify successfully integrated</h2>

  </ng-container>


  <ng-container *ngIf="network=='testing'">

    <h2>Test success</h2>

  </ng-container>


  <Br /><Br />
  <ng-container *ngIf="network != 'shopify'">
  <button mat-raised-button color="primary" (click)="popClose()">Close</button>
  </ng-container>


</div>
